import React from 'react';
import { Dropdown } from 'react-bootstrap';
import PropTypes from 'prop-types';
import './_dropdown-menu.scss';

const CustomDropdown = ({
  dropdownToggle,
  dropdownMenu,
  toggleClassName,
  align,
  menuClassName,
  menuProps,
  dropDownProps,
  dropDownToggleProps,
  ...props
}) => {
  return (
    <Dropdown
      className={`custom-drop-down ${dropDownProps || ''}`}
      {...dropDownProps}
      {...props}
    >
      <Dropdown.Toggle
        {...dropDownToggleProps}
        className={`menu-toggle  ${toggleClassName || ''}`}
      >
        {dropdownToggle}
      </Dropdown.Toggle>
      <Dropdown.Menu
        align={align ? align : 'start'}
        {...menuProps}
        className={`menu-dropdown ${menuClassName || ''}`}
      >
        {dropdownMenu}
      </Dropdown.Menu>
    </Dropdown>
  );
};
CustomDropdown.propTypes = {
  dropdownToggle: PropTypes.element.isRequired,
  toggleClassName: PropTypes.string,
  dropdowwnMenu: PropTypes.element,
  menuClassName: PropTypes.string,
};
export default CustomDropdown;
